import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    DialogActions,
} from '@mui/material';
import { useSnackbar } from 'src/components/snackbar';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch } from 'react-redux';
import { addProject } from 'src/redux/slices/cautionSlice';
import { useServerRequest } from 'src/hooks/useServerRequest';
import { useLocales } from 'src/locales';

interface AddProjectProps {
    open: boolean;
    onClose: () => void;
}

const AddProject: React.FC<AddProjectProps> = ({ open, onClose }) => {
    const [number, setNumber] = useState<string>('');
    const [subject, setSubject] = useState<string>('');
    // const [deadline, setDeadline] = useState<string>('');
    const [deadline, setDeadline] = useState<Date | null>(null);
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const { makeRequest } = useServerRequest();
    const { t } = useLocales();

    const handleSubmit = async () => {
        // Validate inputs
        if (!number || !subject || !deadline) {
            enqueueSnackbar(t('cautions.projects.inputs.alert-reuirements'), { variant: 'error' });
            return;
        }

        try {
            const response = await makeRequest(
                '/projects',
                {
                    method: 'POST',
                    data: {
                        number,
                        subject,
                        deadline,
                    },
                },
                t('cautions.projects.inputs.alert-success')
            );

            if (response.success && response.data) {
                dispatch(addProject(response.data.project));
                onClose();
                setNumber('');
                setSubject('');
                setDeadline(new Date());
            }
        } catch (error) {
            enqueueSnackbar(t('cautions.projects.inputs.alert-error'), { variant: 'error' });
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('cautions.projects.add')}</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    margin="normal"
                    label={t('cautions.projects.inputs.number.label')}
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    placeholder={t('cautions.projects.inputs.number.holder')}
                    required
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label={t('cautions.projects.inputs.subject.label')}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder={t('cautions.projects.inputs.subject.holder')}
                    required
                />
                <DatePicker
                    label={t('cautions.projects.inputs.date.label')}
                    value={deadline}
                    onChange={(newValue) => setDeadline(newValue)}
                    slotProps={{ textField: { fullWidth: true } }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="inherit">
                    {t('common.button.action.cancel')}
                </Button>
                <Button onClick={handleSubmit} variant="contained">
                    {t('common.button.action.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddProject;
